import React from 'react';
import {line as d3line} from 'd3-shape';

/**
 * Draw a guideline for the other data, given a baseline/goal and appropriate scales/margins/dimensions
 *
 * Pass children in order to render additional labels/popups
 */
export default class Guideline extends React.Component {
  render() {
    const {scales, xMin, xMax, baseline, goal} = this.props;
    const {xScale, yScale} = scales;

    const line = d3line()
      .x(d => xScale(d.date))
      .y(d => yScale(d.value));

    const guidelineData = [
      {date: xMin, value: baseline},
      {date: xMax, value: goal},
    ];

    return (
      <g>
        <path className={'guideline-path'} d={line(guidelineData)} />
        {this.props.children}
      </g>
    );
  }
}
